import type { Joint } from './motionPose';

/** Joints are authored in trimmed image coordinates, not atlas-cell coordinates. */
export function boneAttachment(width: number, height: number, start: Joint, end: Joint, from: Joint, to: Joint): { scale: number; rotation: number } {
  const sx = (end.x - start.x) * width, sy = (end.y - start.y) * height;
  const dx = to.x - from.x, dy = to.y - from.y;
  return { scale: Math.hypot(dx, dy) / Math.max(.001, Math.hypot(sx, sy)), rotation: Math.atan2(dy, dx) - Math.atan2(sy, sx) };
}

export const HUNTER_JOINTS = {
  upper: [{ x: .5, y: .06 }, { x: .6, y: .94 }],
  forearm: [{ x: .47, y: .04 }, { x: .5, y: .96 }],
  thigh: [{ x: .5, y: .05 }, { x: .48, y: .94 }],
  shin: [{ x: .5, y: .04 }, { x: .5, y: .96 }],
} as const;

export const POP_JOINTS = {
  upper: [{ x: .46, y: .08 }, { x: .53, y: .94 }],
  forearm: [{ x: .5, y: .05 }, { x: .53, y: .94 }],
  leg: [{ x: .29, y: .04 }, { x: .51, y: .97 }],
} as const;
